/**
 * Sets the fb-component-version attribute on a custom element.
 * @param element The custom element instance.
 * @param version The version string to set.
 */
export function setComponentVersion(element: HTMLElement, version: string): void {
    element.setAttribute('fb-component-version', version);
}
